import { mainSiteUrl } from '@/mocks/categories';
import { useNavigate } from 'react-router-dom';

const heroBgImage = "https://readdy.ai/api/search-image?query=Dreamy%20artistic%20fashion%20boutique%20scene%20with%20soft%20focus%20mannequins%20displaying%20elegant%20clothing%20warm%20ambient%20lighting%20cream%20and%20champagne%20tones%20blurred%20background%20with%20gentle%20bokeh%20effect%20sophisticated%20editorial%20aesthetic%20high%20end%20retail%20atmosphere%20clean%20airy%20composition%20ethereal%20glow%20no%20harsh%20elements&width=1600&height=900&seq=hero-cssbuy-v4&orientation=landscape";

const avatar1 = "https://readdy.ai/api/search-image?query=Tiny%20round%20product%20detail%20macro%20closeup%20of%20warm%20toned%20leather%20accessory%20stitching%20pattern%20soft%20lighting%20abstract%20texture%20editorial%20minimal%20no%20text%20no%20face%20clean%20cream%20background&width=80&height=80&seq=hero-av-1-v3&orientation=squarish";
const avatar2 = "https://readdy.ai/api/search-image?query=Small%20circular%20macro%20crop%20of%20premium%20olive%20fabric%20weave%20texture%20warm%20natural%20lighting%20abstract%20material%20detail%20editorial%20style%20no%20text%20no%20face%20clean%20warm%20gray%20background&width=80&height=80&seq=hero-av-2-v3&orientation=squarish";
const avatar3 = "https://readdy.ai/api/search-image?query=Round%20macro%20closeup%20of%20warm%20golden%20accessory%20buckle%20detail%20soft%20lighting%20abstract%20product%20texture%20editorial%20minimal%20no%20text%20no%20face%20clean%20warm%20background&width=80&height=80&seq=hero-av-3-v3&orientation=squarish";

const avatars = [avatar1, avatar2, avatar3];

export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroBgImage}
          alt="CSSBuy Spreadsheet product collage background"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-10 py-32 md:py-40">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-12 lg:gap-20">
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-8">
              <div className="flex -space-x-2">
                {avatars.map((avatar, i) => (
                  <div key={i} className="w-8 h-8 md:w-10 md:h-10 rounded-full border-2 border-white/70 overflow-hidden bg-background-200">
                    <img
                      src={avatar}
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>
                ))}
              </div>
              <span className="text-white/85 text-xs md:text-sm font-medium tracking-wide">
                10.000+ compradores confiam
              </span>
            </div>

            <h1 className="font-heading text-white leading-none mb-6">
              <span className="block text-4xl md:text-6xl lg:text-7xl font-black tracking-tight">
                CSSBuy
              </span>
              <span className="block text-3xl md:text-5xl lg:text-6xl font-light italic tracking-wide mt-1 md:mt-2">
                Spreadsheet
              </span>
            </h1>

            <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-white text-foreground-900 text-sm md:text-base font-semibold hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer group"
              >
                <span>CSSBuy Sheet</span>
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-300"></i>
              </a>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full border border-white/50 text-white text-sm md:text-base font-semibold hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <span>Buy It Now</span>
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 lg:pb-4">
            <p className="text-white/85 text-sm md:text-base leading-relaxed max-w-md lg:ml-auto">
              Aprenda como usar o CSSBuy Spreadsheet para comprar produtos da China de forma rápida, organizada e segura. Mais barato que agents tradicionais, controle total dos seus pedidos, ideal para iniciantes e avançados.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}